import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { useCltWizardStore } from '@/stores/useCltWizardStore'
import { CltStepHeader } from './CltStepHeader'

export function StepDetails() {
  const name = useCltWizardStore(s => s.name)
  const description = useCltWizardStore(s => s.description)
  const setName = useCltWizardStore(s => s.setName)
  const setDescription = useCltWizardStore(s => s.setDescription)

  return (
    <div className="mx-auto w-full max-w-[680px]">
      <CltStepHeader
        title="Template Details"
        description="Give this Calendar Logic Template a name and describe what it's for."
      />

      <div className="space-y-4 rounded-lg border border-border bg-card p-6">
        <div className="space-y-1.5">
          <Label htmlFor="clt-name">
            Template name <span className="text-destructive">*</span>
          </Label>
          <Input
            id="clt-name"
            placeholder="e.g. Standard Import Logic"
            value={name}
            onChange={e => setName(e.target.value)}
          />
          {name.trim() === '' && (
            <p className="text-xs text-muted-foreground">
              A name is required to continue.
            </p>
          )}
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="clt-description">
            Purpose / description (optional)
          </Label>
          <Textarea
            id="clt-description"
            placeholder="What is this template used for?"
            value={description}
            onChange={e => setDescription(e.target.value)}
            rows={3}
          />
        </div>
      </div>
    </div>
  )
}
